export const codeDeleteUserAccountRequestTypes = [{ label: 'Xóa', value: 'delete' }];


export const approverType = {
    approver: 1,
    itlead: 2,
    ithead: 3,
    assignee: 4,
}